import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PhotosFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PhotosFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M18.51 5.005v9.49c0 2.21-1.79 4-4 4h-9.5c-2.21 0-4-1.79-4-4v-9.49c0-2.21 1.79-4 4-4h9.5c2.21 0 4 1.79 4 4Zm-4-1H5.03c-.55 0-1 .45-1 1v4.84l1.86-1.86c.66-.66 1.72-.65 2.38 0l2.15 2.15c.09.1.2.11.26.11.05 0 .17-.01.26-.11l.79-.8c.31-.32.74-.5 1.19-.5.45 0 .87.17 1.19.49l1.4 1.4v-5.72c0-.55-.45-1-1-1Z" />
          <path d="M20.51 5.82v-.015l-.01.01.01.004Z" />
          <path d="M20.51 5.82v9.935c0 2.62-2.12 4.74-4.74 4.74H5.81c.59 1.46 2.03 2.5 3.7 2.5h7.24c3.45 0 6.24-2.8 6.24-6.24v-7.24a4.004 4.004 0 0 0-2.48-3.696Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default PhotosFilled;